import { InfrastructureError } from '@goodt-wcore/errors';

/**
 * @typedef {import('./HttpTransportError').THttpTransportErrorCode} THttpTransportErrorCode
 */

/**
 * Enum ошибок транспорта
 *
 * @readonly
 * @enum number
 */
export const HttpTransportErrorCode = Object.freeze({
    INTERNAL: 0,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    UNAUTHORIZED: 401,
    INTERNAL_SERVER_ERROR: 500,
    BAD_REQUEST: 400,
    CONFLICT: 409
});

/**
 * Класс-исключение транспортного уровня для запросов к api
 * @class ApiHttpClientError
 */
class HttpTransportError extends InfrastructureError {
    /**
     *
     * @type {typeof import('./HttpTransportError').HttpTransportErrorCode}
     */
    static Code = HttpTransportErrorCode;

    constructor(message, { code, data, reason } = {}) {
        super(message, { code, data, reason });
        this.name = 'HttpTransportError';
    }
}

export { HttpTransportError, HttpTransportError as default };
